import { del as _del, get as _get, getJson as _getJson, getText as _getText, post as _post, put as _put } from "./fetch";

export function get(url: string, data, overrides) {
	return _get(url, data, {
		credentials: "include",
		mode: "cors",
		...overrides,
	});
}

export function getJson(url: string, data, overrides) {
	return _getJson(url, data, {
		credentials: "include",
		mode: "cors",
		...overrides,
	});
}

export function getText(url: string, data, overrides) {
	return _getText(url, data, {
		credentials: "include",
		mode: "cors",
		...overrides,
	});
}

export function post(url: string, data, overrides) {
	return _post(url, data, {
		credentials: "include",
		mode: "cors",
		...overrides,
	});
}

export function put(url: string, data, overrides) {
	return _put(url, data, {
		credentials: "include",
		mode: "cors",
		...overrides,
	});
}

export function del(url: string, overrides) {
	return _del(url, {
		credentials: "include",
		mode: "cors",
		...overrides,
	});
}
